<template>
    <layout>
        <template v-if="!is_cia_enabled">
            <page-search />
        </template>
        <template v-if="is_cia_enabled">
            <cia-search />
        </template>
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import PageSearch from '@/components/search/Cover.vue';
import CiaSearch from '@/components/search/Cia.vue';

import Navigation from '@/models/navigation.js';

export default {
    components: {
        Layout,
        PageSearch,
        CiaSearch,
    },
    data() {
        return {
            is_cia_enabled: false,
        };
    },
    mounted() {
        Navigation.setCurrentLink('cover');
        if (this.$store.state.user.modules.cia) {
            this.is_cia_enabled = true;
        }
    },
};
</script>
